/*
 * @file service形式的portalDialog
 * @example

import PortalDialogWrapper from '/common-new/components/modalDialog/PortalDialogWrapper'
import DemoComponent from '.../...'


export default class Index extends React.Component {
    constructor(props) {
        super(props);

        this.onPortalDialogWrapperClick = this.onPortalDialogWrapperClick.bind(this)
        this.onPortalDialogWrapperCloseClick = this.onPortalDialogWrapperCloseClick.bind(this)
        this.portalDialogWrapper = new PortalDialogWrapper(this);
    }

    onPortalDialogWrapperClick() {
        this.portalDialogWrapper.open();
    }

    onPortalDialogWrapperCloseClick() {
        this.portalDialogWrapper.close();
    }

    render() {
        const props = this.props;
        return (
            <div>

                {this.portalDialogWrapper.render(
                    <p>
                        <DemoComponent />
                        <a onClick={this.onPortalDialogWrapperCloseClick}>
                            PortalDialogWrapper
                        </a>This thing was portaled!</p>
                )}

            </div>
        );
    }
}

*/

import React, { Component } from 'react';
import PortalDialog from './portalDialog';

export default class PortalDialogWrapper {
    constructor(public component: Component<{ [props: string]: any }, { show: boolean } & { [props: string]: any }>) {
        this.component = component;
    }

    public open() {
        this.component.setState({
            show: true,
        });
    }

    public close() {
        this.component.setState({
            show: false,
        });
    }

    public render(child: any) {
        return <PortalDialog show={this.component.state.show}>{child}</PortalDialog>;
    }
}
